import useSWR from 'swr';
import axios from 'axios';

function useNotificationPreferences() {
  return useSWR(
    `${process.env.REACT_APP_API_URL}/users/me/notification-preferences`,
    async (url) => {
      const { data } = await axios.get(url);
      return data;
    }
  );
}

export default useNotificationPreferences;
